exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "img[data-v-44f5ab2d]{max-width:none!important}.centered-image[data-v-44f5ab2d]{display:none;opacity:0;transition:all .4s}.centered-image.loaded[data-v-44f5ab2d]{opacity:1}", ""]);

